<table *ngIf="providedData" mat-table [dataSource]="dataSource?.slice(startIndex, endIndex)">
  <ng-container *ngFor="let column of columns;let indexOfElement=index;" matColumnDef="{{column}}">
    <ng-container *ngIf="column !== 'actions'">
      <th *matHeaderCellDef mat-header-cell style="width: 30%">{{displayColumns[indexOfElement]}}</th>
      <td mat-cell *matCellDef="let element"> {{element[column]}} </td>
    </ng-container>
    <ng-container *ngIf="column === 'actions'">
      <th *matHeaderCellDef mat-header-cell style="width: 10%;">Actions</th>
      <td *matCellDef="let element; let i = index" mat-cell class="justify-right action-button">
        <button [matMenuTriggerFor]="menu" mat-button (click)="$event.stopPropagation();">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button (click)="deleteRow(element)" class="action-btn" mat-button>
            <i class="material-icons">delete</i>
            <span>Delete</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>
  </ng-container>
  <tr *matHeaderRowDef="columns" mat-header-row></tr>
  <tr *matRowDef="let row; columns: columns;" mat-row (click)="openRow(row)"></tr>
</table>

<app-local-paginator [pageSize]="[10,20,50]"
                     [itemsLength]="dataSource?.length"
                     [displayedPages]="3"
                     (changePage)="onChangePage($event)">
</app-local-paginator>
